import React, { FC, useState } from 'react'
import { Col, Form, Row } from 'antd'
import { FormNames } from 'Constants/FormNames'
import { useAppDispatch } from 'Src/hooks'
import { MODAL_NAME } from 'Constants/ModalName'
import { FieldNames } from 'Constants/FieldNames'
import { useEffectOnce } from 'Src/hooks/useEffectOnce'
import {
	BtnComponent,
	FormNotificationComponent,
	Indent,
	InputComponent,
	UIHtmlType,
	UITypes,
} from 'LibNeo'
import { isErrorBizon } from 'Helpers'
import { ComponentPropsEmailModal, modalsSlice, codeEmailSelectors, emailSlice } from 'Modules'

const actions = {
	hideModal: modalsSlice.actions.hideModal,
	initConfirmEmail: emailSlice.actions.initConfirmEmail,
	confirmEmail: emailSlice.actions.confirmEmail,
}
const EmailModalComponent: FC<ComponentPropsEmailModal> = ({
	form,
	callback,
	url,
	params = null,
}) => {
	const [translateErrorUser, setTranslateErrorUser] = useState<string | null>(null)
	const { hideModal, initConfirmEmail, confirmEmail } = useAppDispatch(actions)
	const codes = codeEmailSelectors.selectCodeEmail

	const setBlockErrorUser = (res) => setTranslateErrorUser(isErrorBizon(res))

	const handleSubmit = (e: React.FormEvent<EventTarget>) => {
		e.preventDefault()
		form.validateFields((err, values) => {
			if (!err) {
				const code = values[FieldNames.EMAIL_CONFIRMATION_CODE]
				form.resetFields()
				confirmEmail({
					url,
					code,
					callback,
					errorCallback: (res) => setBlockErrorUser(res),
					params,
				})
			}
		})
	}

	const closeModal = () => {
		hideModal(MODAL_NAME.EMAIL)
	}

	useEffectOnce(() => {
		if (!codes[`${url}`])
			initConfirmEmail({ url, errorCallback: (res) => setBlockErrorUser(res), params })
		return () => {
			closeModal()
		}
	})

	return (
		<>
			{translateErrorUser ? (
				<FormNotificationComponent type={UITypes.DANGER} message={translateErrorUser} />
			) : (
				<Form onSubmit={handleSubmit}>
					<Row>
						<Col span={24} className="centered_block">
							<InputComponent
								form={form}
								fieldName={FieldNames.EMAIL_CONFIRMATION_CODE}
								fieldOptions={{
									rules: [
										{
											required: true,
											message: 'заполните код',
										},
									],
								}}
								allowClear
								placeholder="Введите код"
							/>
						</Col>
					</Row>
					<Row type="flex" justify="center">
						<Col>
							<Indent top={10}>
								<Row gutter={16} type="flex">
									<Col>
										<BtnComponent title="Отмена" outline onClick={closeModal} />
									</Col>
									<Col>
										<BtnComponent title="Подтвердить" htmlType={UIHtmlType.SUBMIT} />
									</Col>
								</Row>
							</Indent>
						</Col>
					</Row>
				</Form>
			)}
		</>
	)
}
export const EmailModal = Form.create({ name: FormNames.COMMON.CODE_EMAIL })(EmailModalComponent)
